import React from 'react';

export const CameraCanvas = React.forwardRef(({ isImageCaptured }, ref) => (
  <canvas
    id="canvas"
    className={!isImageCaptured ? 'hidden' : ''}
    ref={ref}
  />
));

export const CameraViewFinder = React.forwardRef(({ isImageCaptured }, ref) => (
  <video
    id="player"
    autoPlay={true}
    playsInline={true}
    ref={ref}
    className={isImageCaptured ? 'hidden' : ''}
  />
));
